const ticketStatus ={
  1: "Open",
  2: "In progress",
  3: "Pending",
  4: "Soft close",
  5: "Ignore",
  6: "Closed",
  7: "Reopened",
  8: "Reassigned"
}

export default ticketStatus;